// extracted by mini-css-extract-plugin
module.exports = {"title":"feed_title__1BBPB text text_type_main-large pt-10 pb-5 ml-5 mr-5","contentArea":"feed_contentArea__1GtPG"};